import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { roles } from '@/modules/auth/roles';
import { endpoints as userEndpoints } from '@/modules/users/constants';

/**
 * Where an OAuth callback (LinkedIn, Slack) sends the user once signed in:
 * a specific `returnTo` stays, the root becomes `/hm` for hiring managers.
 */
export const getRoleBasedReturnTo = async (returnTo: string) => {
  const parsedReturnTo = new URL(returnTo, window.location.origin);
  if (parsedReturnTo.pathname !== '/') {
    return returnTo;
  }

  try {
    const { data: currentUser } = await fetchClient.GET(
      userEndpoints.currentUser,
    );
    const isHiringManager = currentUser?.roles?.includes(roles.HiringManager);
    const basePath = isHiringManager ? '/hm' : '/';

    return `${basePath}${parsedReturnTo.search}${parsedReturnTo.hash}`;
  } catch {
    return returnTo;
  }
};
